import { jsx as _jsx } from "react/jsx-runtime";
import { Primary } from "@cinch-labs/design-system";
import { Wrapper } from "@cinch-nx/shared-ui";
import styles from "./find-a-car-cta.module.css";
import { scrollToElement } from "./find-a-car-cta.helpers";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import { financeBudgetTopButton } from "../../tracking/tracking-events";
function FindACarCta({ i18n , triggerPointRef  }) {
    const { trackEvent  } = useAnalytics();
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: {
            container: styles.findACarCtaContainer,
            inner: styles.findACarCtaInner
        },
        children: /*#__PURE__*/ _jsx(Primary, {
            classNames: {
                button: styles.findACarCta
            },
            onClick: ()=>{
                scrollToElement(triggerPointRef);
                trackEvent(financeBudgetTopButton());
            },
            children: i18n.ctaText
        })
    });
}
export default FindACarCta;
